<template>
  <div class="table-wrapper">
    <div class="table-header" v-if="!!$slots['table-header']">
      <slot name="table-header" />
    </div>
    <div :class="`table-container nice-scrollbar ${overflowAll ? 'overflow-all' : ''}`">
      <table>
        <slot />
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    overflowAll: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  border: 1px solid var(--table-border-color);
  border-radius: 10px;

  @media (max-width: 767px) {
    &.table-sm {
      table {
        display: table;
        width: 100%;
      }
    }
  }
}

.table-container {
  border-radius: 10px;
  max-width: calc(100vw - 12px);

  &.overflow-small {
    @media (max-width: 767px) {
      overflow-x: auto;
      white-space: nowrap;
    }
  }

  &.overflow-all {
    overflow-x: auto;
    white-space: nowrap;
  }
}

.filter-settings {
  border-top: 1px solid var(--table-header-border-color);
  padding: 15px;
  display: block;
}

.table-header {
  background-color: white;
  border-radius: 10px 10px 0 0;
  // border-bottom: 1px solid var(--table-header-border-color);
  // position: sticky;
  // top: 56px;
  // display: flex;
  // flex-direction: column;
  z-index: 2;

  /*.filter-bar {
    display: flex;
    flex-direction: column;

    & > * {
      align-items: center;
      display: flex;
      flex: 1;
      padding: 0 15px;
      margin-bottom: 10px;

      &:first-child {
        margin-top: 10px;
      }
    }

    @media (min-width: 768px) {
      flex-direction: row;

      & > * {
        padding: 15px;
        margin: 0 10px;

        &:first-child {
          margin-top: 0;
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }*/

  @media (min-width: 1024px) {
    top: 0;
  }
}

table {
  display: block;
  white-space: nowrap;

  .header {
    border-bottom: 1px solid var(--table-header-border-color);

    & > * {
      font-size: 14px;
      font-weight: 400;
      padding: 15px;
      background-color: var(--table-header-bg);

      &:first-child {
        border-radius: 10px 0 0 0;
      }

      &:last-child {
        border-radius: 0 10px 0 0;
      }

      &:only-child {
        border-radius: 10px 10px 0 0;
      }

      &:not(.ta-c):not(.ta-r) {
        text-align: left;
      }

      @media (min-width: 768px) {
        font-size: 16px;
      }
    }
  }

  & > a {
    display: table-row;
    vertical-align: middle;
  }

  & > *:not(.header) {
    background-color: white;

    & > * {
      font-size: 14px;
      padding: 15px;

      @media (min-width: 768px) {
        font-size: 16px;
      }
    }

    &.selected {
      background-color: var(--color-cta-blue);
      color: white;

      .blue {
        color: var(--color-cta-gray);
      }
    }

    &.empty-list {
      color: var(--color-cta-gray);
    }

    &:hover:not(.selected):not(.empty-list) {
      background-color: var(--table-item-hover-bg);
      cursor: pointer;
    }
  }

  th {
    &.sortable {
      &:hover {
        cursor: pointer;

        &:not([data-sorting-on="true"]) {
          &:after {
            font-family: 'icomoon';
            margin-left: 4px;
            font-size: 13.5px;
            content: "\e970";
            color: rgb(154, 154, 154);
          }
        }
      }

      &[data-sorting-on="true"] {
        &:after {
          font-family: 'icomoon';
          margin-left: 4px;
          font-size: 13.5px;
        }

        &[data-sorting-direction="desc"] {
          &:after {
            content: "\e970"
          }
        }

        &[data-sorting-direction="asc"] {
          &:after {
            content: "\e971"
          }
        }
      }
    }
  }

  th, td {
    &.no-padding-right {
      padding-right: 0;
    }

    &.extra-padding {
      padding-left: 25px;
      padding-right: 25px;
    }
  }

  & > tr, & > a {
    &:not(:last-child) {
      td {
        border-bottom: 1px solid var(--table-item-border-color);
      }
    }
  }

  .strong {
    font-weight: 500;
  }

  td.ellipsis {
    position: relative;
    &:before {
      content: '&nbsp;';
      visibility: hidden;
    }

    & > div:first-child {
      display: inline;
      position: absolute;
      left: 15px;
      right: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    // max-width: 0;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    /*& > * {
      max-width: 250px;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (min-width: 768px) {
        max-width: 350px;
      }
    }*/
  }

  .blue {
    color: var(--color-cta-blue);
  }

  .gray {
    color: var(--color-cta-darkgray)
  }

  td, th {
    &.center-y {
      vertical-align: center;
    }

    &.only-desktop {
      display: none;
      @media (min-width: 768px) {
        display: table-cell;
      }
    }

    .only-mobile {
      @media (min-width: 768px) {
        display: none;
      }
    }
    .only-desktop {
      display: none;
      @media (min-width: 768px) {
        display: block;
      }
    }
  }

  tr, a {
    &.only-desktop {
      display: none;
      @media (min-width: 768px) {
        display: table-row;
      }
    }
  }

  tr, a {
    td:last-child {
      .arrow {
        font-size: 28px;
      }
    }
  }

  & > tr:last-child, & > a:last-child {
    border-radius: 0 0 10px 10px;

    td:first-child, th:first-child {
      border-radius: 0 0 0 10px;
    }

    td:last-child, th:last-child {
      border-radius: 0 0 10px 0;
    }

    td:only-child, th:only-child {
      border-radius: 0 0 10px 10px;
    }
  }
}
</style>
